<button
  class="button-close"
  mat-icon-button
  disableRipple
  (click)="onCloseClick()"
>
  <mat-icon svgIcon="close"></mat-icon>
</button>
<div class="image-container">
  <img
    [src]="data.imageUrl"
    imgErrLog
  />
</div>
<div class="content-container">
  <span class="item-name">{{ data.skuName }}</span>
</div>
